import { useAuthStore } from '@/stores/auth.store';

export function useAuth() {
  const user = useAuthStore((s) => s.user);
  const status = useAuthStore((s) => s.status);
  const clearAuth = useAuthStore((s) => s.clearAuth);

  return {
    user,
    isAuthenticated: status === 'authenticated',
    isLoading: status === 'loading',
    logout: clearAuth,
  };
}
